import { Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";

export const TimelinePanel = ({ q, setQ, quoteId, action }) => (
  <div>
    <h3 className="text-xs font-bold uppercase tracking-widest text-[#C85A32] mb-2">Timeline evento</h3>
    <div className="space-y-2">
      {(q.timeline || []).map((t, i) => (
        <div key={`${t.time}-${t.label}-${i}`} className="flex gap-2 items-center">
          <Input data-testid={`timeline-time-${i}`} type="time" className="w-28 h-8 bg-[#1E293B] border-slate-700 text-white" value={t.time} onChange={(e) => setQ({ ...q, timeline: q.timeline.map((x, j) => (j === i ? { ...x, time: e.target.value } : x)) })} />
          <Input data-testid={`timeline-label-${i}`} className="h-8 bg-[#1E293B] border-slate-700 text-white" value={t.label} onChange={(e) => setQ({ ...q, timeline: q.timeline.map((x, j) => (j === i ? { ...x, label: e.target.value } : x)) })} />
          <button onClick={() => setQ({ ...q, timeline: q.timeline.filter((_, j) => j !== i) })} className="text-slate-500 hover:text-rose-400"><Trash2 className="w-4 h-4" /></button>
        </div>
      ))}
    </div>
    <div className="flex gap-2 mt-2">
      <Button size="sm" variant="outline" className="border-slate-600 text-slate-900" onClick={() => setQ({ ...q, timeline: [...(q.timeline || []), { time: "18:00", label: "" }] })}>+ Voce timeline</Button>
      <Button data-testid="save-timeline-button" size="sm" className="bg-[#C85A32] hover:bg-[#a94a28]" onClick={() => action(() => api.put(`/admin/quotes/${quoteId}/timeline`, { timeline: q.timeline }), "Timeline salvata")}>Salva timeline</Button>
    </div>
  </div>
);
